import { createApp } from 'vue'
import App from './App.vue'
import i18n from './i18n'
import '../css/main.css'

// 创建Vue应用实例
const app = createApp(App)

// 使用插件
app.use(i18n)

console.log('Starting Vue app initialization...')

// 错误处理
app.config.errorHandler = (err, vm, info) => {
  console.error('Vue Error:', err)
  console.error('Error Info:', info)
}

// 全局错误处理
window.addEventListener('unhandledrejection', event => {
  console.error('Unhandled Promise Rejection:', event.reason)
})

window.addEventListener('error', event => {
  console.error('Global Error:', event.error)
})

// 挂载应用
try {
  app.mount('#app')
  console.log('Vue app mounted successfully')
} catch (error) {
  console.error('Failed to mount Vue app:', error)
  document.body.innerHTML += `<div style="color: red; padding: 20px;">Failed to initialize app: ${error.message}</div>`
} 